import { style } from '@vanilla-extract/css';
import { mobile } from '../theme/media';

/** Flex column container */
export const flexColumn = style({
  display: 'flex',
  flexDirection: 'column',
});

/** Flex row container */
export const flexRow = style({
  display: 'flex',
  flexDirection: 'row',
});

/** 칩 줄 — `Button variant="chip"` 묶음의 박스 없는 flex. `role="group"` 래퍼에 건다. */
export const chipRow = style({
  display: 'flex',
  gap: '6px',
  flexWrap: 'wrap',
});

/** Flex center (both axes) */
export const flexCenter = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

/** Flex fill: takes remaining space in a column layout */
export const flexFill = style({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
});

/** Screen-reader only: visually hidden but accessible */
export const srOnly = style({
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
});

/** Hidden input (file inputs, etc.) — uses visually-hidden instead of display:none
 *  so that programmatic .click() still opens the file picker in all browsers. */
export const hiddenInput = style({
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  opacity: 0,
  pointerEvents: 'none',
});

/** Text center alignment */
export const textCenter = style({
  textAlign: 'center',
});

/** SVG filter container: hidden, zero dimensions */
export const svgFilterContainer = style({
  position: 'absolute',
  width: 0,
  height: 0,
  overflow: 'hidden',
});

/** Hidden on mobile (≤768px) — 테이블 보조 컬럼 숨김용 */
export const mobileHide = style({
  '@media': {
    [mobile]: {
      display: 'none',
    },
  },
});
